import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";

const ChatIcon: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={"0 0 32 32"}
        width={props.width ?? 32}
        height={props.height ?? 32}
    >
        <path
            fill={props.fill}
            d="M32 21.333V28a4 4 0 0 1-4 4h-6.667a10.667 10.667 0 0 1-9.226-5.333 14.622 14.622 0 0 0 2.989-.331 7.983 7.983 0 0 0 6.237 2.997H28A1.333 1.333 0 0 0 29.333 28v-6.667a7.984 7.984 0 0 0-3.002-6.237c.214-.982.327-1.984.336-2.99A10.667 10.667 0 0 1 32 21.334Zm-8.03-8.465A12 12 0 0 0 11.131.031 12.557 12.557 0 0 0 0 12.392v6.72C0 22.488 2.01 24 4 24h7.6a12.559 12.559 0 0 0 12.37-11.132ZM18.6 5.401a9.358 9.358 0 0 1 2.71 7.28 9.818 9.818 0 0 1-9.71 8.652H4c-1.237 0-1.333-1.7-1.333-2.221v-6.72a9.816 9.816 0 0 1 8.653-9.701A9.35 9.35 0 0 1 18.6 5.4Z"
        />
    </svg>
)
export default ChatIcon
